import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
function Stripe() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(document.location.search);
  const code = new URLSearchParams(search).get("code");
  // Short-lived, agency-scoped token minted by GET /agency/stripe/connect-token
  // before this flow left for Stripe - not the user's session token, which
  // this top-level tab (landed here straight from Stripe, outside the
  // iframe that owns the real session) has no reliable way to still have.
  const connectToken = searchParams.get("state");
  const request = useRequest();
  const queryClient = useQueryClient();

  const updateAgency = async (creds) => {
    const payload = {
      token: connectToken,
      stripe: {
        key: creds.access_token,
        refresh_token: creds.refresh_token,
        publish_key: creds.stripe_publishable_key,
        account_id: creds.stripe_user_id,
        access_token: creds.access_token,
      },
    };

    const { response } = await request(ReqMethods.PUT, "/agency/stripe/complete-connect", { payload });

    if (!response) throw new Error("Something went wrong while integration, please try latter");

    return "Account connected successfully";
  };

  const getCreds = async () => {
    const { response } = await request(ReqMethods.GET, "/agency/stripe/integrate", {
      query: `code=${code}`,
    });
    if (!response) throw new Error("Something went wrong while integration, please try latter");
    return updateAgency(response.data);
  };

  const { mutate, data, error, isError } = useMutation({
    mutationFn: getCreds,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agency"] });
      // Mirrors the original: close the popup 2s after showing the success message.
      setTimeout(() => window.close(), 2000);
    },
  });

  useEffect(() => {
    mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const done = isError || !!data;

  return (
    <DashboardLayout>
      <SoftBox>
        {!done && <SoftBox>Integrating please wait...</SoftBox>}
        {done && (
          <SoftBox>
            {isError ? error.message : data}
            <SoftButton onClick={() => navigate(-2)}>Go Back</SoftButton>
          </SoftBox>
        )}
      </SoftBox>
    </DashboardLayout>
  );
}

export default Stripe;
